import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import BigButton from 'components/BigButton';
import FullScreenView from 'components/FullScreenView';
import configuration from 'configuration';

const MenuScreen = ({path, items}: {path: string; items: string[]}) => {
  const {t} = useTranslation();

  const text: string | null = useMemo(
    () => t(configuration.path2langKey(path, 'text'), {defaultValue: null}),
    [path, t],
  );

  const numItems = useMemo(() => {
    const n = parseInt(t(configuration.path2langKey(path, '$screen'), {fallbackLng: 'de'}), 10);
    return Number.isNaN(n) ? items.length : n;
  }, [items.length, path, t]);

  const image = useMemo(() => configuration.assetsPath(path) + 'screen.jpg', [path]);
  const imagePosition = useMemo(() => {
    return t(configuration.path2langKey(path, '$image.position'), {
      fallbackLng: 'de',
      defaultValue: undefined,
    });
  }, [path, t]);

  return (
    <FullScreenView image={image} imagePosition={imagePosition}>
      {text && <Text className="no-select">{text}</Text>}
      {items
        .filter((_, index) => index < numItems)
        .map(item => {
          const k = configuration.path2langKey(item, 'T');
          return (
            <BigButton key={item} path={item}>
              {path === '/'
                ? configuration.languages.map(l => (
                    <React.Fragment key={l}>
                      {t(k, {lng: l}).replaceAll('\\n', '\n')}
                      <br />
                    </React.Fragment>
                  ))
                : t(k).replaceAll('\\n', '\n')}
            </BigButton>
          );
        })}
    </FullScreenView>
  );
};
export default MenuScreen;

const Text = styled.div`
  width: 60%;
  padding: 50px;
  text-align: center;
  font-size: 25px;
  background-color: var(--color-alpha-white);
  margin-bottom: calc(4 * var(--margin));
`;
